import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MarginIcon(props: IconProps) {
    return <Icon {...props} iconKey={"margin"}/>
}
